module.exports = __webpack_public_path__ + "static/img/new_logo_2.c6193d0a.png";